import { BuildingType, MapDecoration } from "./types";

// Demo buildings (swap with API later)
// Each building references two sprites: `builtImg` (constructed) and
// `notBuiltImg` (empty plot). Building.tsx picks between them based on the
// API building state (NotHave -> notBuiltImg, otherwise -> builtImg).
// `scale` values are tuned so the new (higher-resolution) Figma art keeps
// roughly the same on-screen footprint the previous sprites had.
export const buildings: BuildingType[] = [
  {
    id: 3,
    builtImg: "/assets/images/map/built/cleg-mine.png",
    notBuiltImg: "/assets/images/map/not-built/cleg-mine.png",
    x: 993,
    y: 919,
    scale: 0.61,
    name: "Cleg Mine",
    level: 0,
    progress: 50,
    icon: "/assets/images/icons/cleg.png",
    type: "dynamic",
  },
  {
    id: 4,
    builtImg: "/assets/images/map/built/stone-mine.png",
    notBuiltImg: "/assets/images/map/not-built/stone-mine.png",
    x: 1265,
    y: 692,
    scale: 0.6,
    name: "Stone Mine",
    level: 0,
    icon: "/assets/images/icons/stone.png",
    progress: 50,
    type: "dynamic",
  },
  {
    id: 5,
    builtImg: "/assets/images/map/built/iron-mine.png",
    notBuiltImg: "/assets/images/map/not-built/iron-mine.png",
    x: 698,
    y: 774,
    scale: 0.6,
    name: "Iron Mine",
    level: 0,
    icon: "/assets/images/icons/metal.png",
    progress: 50,
    type: "dynamic",
  },

  {
    id: 7,
    builtImg: "/assets/images/map/built/research.png",
    notBuiltImg: "/assets/images/map/not-built/research.png",
    x: 1267,
    y: 1136,
    scale: 0.6,
    name: "Research",
    level: 0,
    progress: 50,
    type: "dynamic",
  },
  {
    id: 6,
    builtImg: "/assets/images/map/built/barracks.png",
    notBuiltImg: "/assets/images/map/not-built/barracks.png",
    x: 1607,
    y: 1358,
    scale: 0.6,
    name: "Barracks",
    level: 0,
    icon: "/assets/images/viking.png",
    progress: 50,
    type: "dynamic",
  },
  {
    id: 12,
    builtImg: "/assets/images/map/built/dungeon.png",
    notBuiltImg: "/assets/images/map/not-built/dungeon.png",
    x: 2195,
    y: 821,
    scale: 0.6,
    name: "Dungeon",
    level: 0,
    icon: "/assets/images/dungeon.png",
    progress: 50,
    link: "/dungeon/select",
    type: "static",
    namePosition: {
      x: -95,
      y: 104,
    },
    decorations: [
      {
        image: "/assets/images/map/road.png",
        offsetX: 260,
        offsetY: -410,
        scale: 1.5,
        zIndex: -1,
        anchor: 0.5,
      },
    ],
  },
  {
    id: 15,
    builtImg: "/assets/images/map/built/market.png",
    notBuiltImg: "/assets/images/map/not-built/market.png",
    x: 872,
    y: 1382,
    scale: 0.6,
    name: "Market",
    level: 0,
    icon: "/assets/images/dungeon.png",
    progress: 50,
    link: "/marketplace",
    type: "static",
    namePosition: {
      x: -7,
      y: 46,
    },
   decorations: [
      {
        image: "/assets/images/map/road.png",
        offsetX: 872,
        offsetY: 1382,
        scale: 1.04,
        zIndex: -1,
        anchor: 0.5,
      },
    ],
  },
  {
    id: 16,
    builtImg: "/assets/images/map/built/referral.png",
    notBuiltImg: "/assets/images/map/not-built/referral.png",
    x: 667,
    y: 1220,
    scale: 0.6,
    name: "Referral",
    link: "/referrals",
    level: 0,
    icon: "/assets/images/dungeon.png",
    progress: 50,
    type: "static",
    namePosition: {
      x: -48,
      y: 81,
    }
  },
  {
    id: 17,
    builtImg: "/assets/images/map/built/guild.png",
    notBuiltImg: "/assets/images/map/not-built/guild.png",
    x: 1783,
    y: 1135,
    scale: 0.6,
    name: "Guild",
    link: "/guild",
    level: 0,
    icon: "/assets/images/dungeon.png",
    progress: 50,
    type: "static",
    namePosition: {
      x: -25,
      y: 82,
    }
  },
  {
    id: 18,
    builtImg: "/assets/images/map/built/lands.png",
    notBuiltImg: "/assets/images/map/not-built/lands.png",
    x: 990,
    y: 544,
    scale: 0.6,
    name: "My Lands",
    link: "/lands",
    level: 0,
    icon: "/assets/images/dungeon.png",
    progress: 50,
    type: "static",
    namePosition: {
      x: -9,
      y: 62,
    }
  },
  {
    id: 19,
    builtImg: "/assets/images/map/built/treasure.png",
    notBuiltImg: "/assets/images/map/not-built/treasure.png",
    x: 2317,
    y: 1444,
    scale: 0.6,
    name: "Treasure Island",
    link: "/treasure/select",
    level: 0,
    icon: "/assets/images/dungeon.png",
    progress: 50,
    type: "static",
    namePosition: {
      x: -124,
      y: 136,
    }
  },
  {
    // NOTE: Arena is newly added from the Figma design. Its id (20), map
    // position, scale and link ("/arena") are placeholders — adjust to match
    // the real arena route/buildingId and desired spot on the map.
    id: 20,
    builtImg: "/assets/images/map/built/arena.png",
    notBuiltImg: "/assets/images/map/not-built/arena.png",
    x: 1550,
    y: 978,
    scale: 0.62,
    name: "Arena",
    link: "/arena",
    level: 0,
    icon: "/assets/images/dungeon.png",
    progress: 50,
    type: "static",
    namePosition: {
      x: -27,
      y: 115,
    },
  },
    {
    // NOTE: Arena is newly added from the Figma design. Its id (20), map
    // position, scale and link ("/arena") are placeholders — adjust to match
    // the real arena route/buildingId and desired spot on the map.
    id: 21,
    builtImg: "/assets/images/map/construction.png",
    notBuiltImg: "/assets/images/map/not-built/arena.png",
    x: 2375,
    y: 1044,
    scale: 0.7,
    name: "Arena",
    level: 0,
    progress: 50,
    type: "static",

  },
];

export const mapDecorations: MapDecoration[] = [
  // {
  //   id: "christmas-tree",
  //   image: "/assets/images/map/tree.png",
  //   x: 1598,
  //   y: 980,
  //   scale: 0.7,
  //   anchor: { x: 0.5, y: 1 },
  //   zIndex: 2,
  // },
];
